<template>
  <!-- <div class="ticket-updater__container"> -->

    <!-- <aside class="ticket-updater__navigator menu">

      <p class="menu-label">
        Ticket Navigator
      </p>

      <ul class="menu-list">
      </ul>

    </aside> -->

    <div class="ticket-updater__container">

      <div class="columns" v-if="ticket">

        <div class="column is-one-quarter">

          <button
            v-if="editable"
            :disabled="!changes || changes == 0"
            @click="saving = true"
            class="field button is-link is-fullwidth mb-5">
            Save Changes
          </button>

          <div class="field">
            <label class="label">Ticket No.</label>
            <p>{{ ticket.id }}</p>
          </div>
          <div class="field">
            <label class="label">Raised By</label>
            <p>{{ ticket.created_user.display_name }}</p>
          </div>
          <div class="field">
            <label class="label">Raised On</label>
            <p>{{ format(parse(ticket.created_on)) }}</p>
          </div>
          <div class="field">
            <label class="label">Ticket Title</label>
            <p>{{ ticket.title }}</p>
          </div>
          <div class="field">
            <label class="label">Ticket Description</label>
            <p v-html="ticket.desc"></p>
          </div>
          <div class="field">
            <label class="label">File Upload</label>
            <template v-if="ticket.images">
              <a
                v-if="ticket.images[0]"
                :href="ticket.images[0]" 
                target="_blank">
                Attachment
              </a>
            </template>
            <span class="has-text-grey" v-else>
              No files attached
            </span>
          </div>
        </div>

        <div class="column is-three-quarters">

          <div class="columns is-multiline">

            <div class="column is-one-third">
              <div class="label-and-button pb-2">
                <label class="label mb-0">Ticket Category*</label>
                <span 
                  v-if="editable"
                  class="tag pointer" 
                  @click="managingCategories = true">
                  <span class="icon is-small">
                    <i class="fas fa-plus"></i>
                  </span>
                  <span>Manage Categories</span>
                </span>
              </div>
              <v-select
                :disabled="!editable"
                v-if="categories.length > 0"
                required
                item-text="category"
                item-value="id"
                :options="categories"
                v-model="ticket.category_id"
                @input="update('category_id', $event)"
              />
              <div v-else class="has-text-grey py-2">
                No categories available
              </div>
            </div>

            <div class="column is-one-third">
              <label class="label">Ticket Priority</label>
              <v-select
                :disabled="!editable"
                :options="priorities"
                v-model="ticket.priority"
                @input="update('priority', $event)"
              />
            </div>

            <div class="column is-one-third">
              <label class="label">Status</label>
              <v-select
                :disabled="!editable"
                :options="statuses"
                v-model="ticket.status"
                @input="update('status', $event)"
              />
            </div>

          </div>

          <div class="columns is-multiline">

            <div class="column is-one-quarter">
              <label class="label">User Assigned</label>
              <v-select
                v-if="users.length > 0"
                :disabled="!editable"
                :options="users"
                item-value="id"
                item-text="display_name"
                v-model="ticket.admin_user.id"
                @input="update('admin_assigned', $event)"
              />
            </div>
            
            <div class="column is-one-quarter">
              <label class="label">Expected Resolution Date</label>
              <v-datepicker
                :disabled="!editable"
                v-model="ticket.exp_solution_date"
                @input="update('exp_solution_date', $event.toISOString())">
              </v-datepicker>
            </div>
            
            <div class="column is-one-quarter">
              <div class="label-and-button pb-2">
                <label class="label mb-0">
                  Company Used
                </label>
                <span 
                  v-if="editable"
                  class="tag pointer" 
                  @click="addingCompany = true">
                  <span class="icon is-small">
                    <i class="fas fa-plus"></i>
                  </span>
                  <span>Add Company</span>
                </span>
              </div>
              <v-select
                v-if="companies.length != 0"
                :options="companies"
                :disabled="!editable"
                item-text="name"
                item-value="id"
                v-model="ticket.company_id"
                @input="update('company_id', $event)"
              />
              <p 
                v-else
                class="pt-2 has-text-grey">
                No companies in this category
              </p>
            </div>

            <div class="column is-one-quarter">
              <div class="label-and-button pb-2">
                <label class="label mb-0">
                  Contact Used
                </label>
                <span 
                  v-if="editable && ticket.company_id"
                  class="tag pointer" 
                  @click="addingContact = true">
                  <span class="icon is-small">
                    <i class="fas fa-plus"></i>
                  </span>
                  <span>Add Contact</span>
                </span>
              </div>
              <v-select
                v-if="contacts.length != 0"
                :options="contacts"
                :disabled="!editable"
                item-text="first_name"
                item-value="id"
                v-model="ticket.contact_id"
                @input="update('contact_id', $event)"
              />
              <p 
                v-else
                class="pt-2 has-text-grey">
                No contacts available
              </p>
            </div>

          </div> 

          <div class="field">
            <label class="label">Notes</label>
            <v-rich-text
              v-if="editable"
              v-model="ticket.admin_notes"
              min-height="120px">
            </v-rich-text>
            <div v-else>
              <span 
                v-if="!ticket.admin_notes" 
                class="has-text-grey">
                There are no notes
              </span>
              <span v-html="ticket.admin_notes">
              </span>
            </div>
          </div>

          <hr/>

          <section v-if="ticket.history.length > 0">
            <header class="title is-5">
              Ticket Update History
            </header>
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th>Update Date</th>
                  <th>Priority</th>
                  <th>Status</th>
                  <th>Comments</th>
                </tr>
              </thead>
              <tbody>
                <tr 
                  v-for="(update, i) in ticket.history" 
                  :key="i">
                  <td>
                    {{ format(parse(update.created_on)) }}
                  </td>
                  <td>
                    {{ update.priority }}
                  </td>
                  <td>
                    {{ update.status }}
                  </td>
                  <td>
                    {{ update.comments }}
                  </td>
                </tr>
              </tbody>
            </table>
          </section>

        </div>

        <!-- <div class="column is-one-quarter">

          <button
            class="field button is-fullwidth">
            Resolve Issue
          </button>
          <button
            class="field button is-fullwidth">
            Close Issue Without Resolving
          </button>
        </div> -->

      </div>

      <update-ticket-modal
        v-if="ticket && ticket.id"
        v-model="saving"
        :ticket-id="ticket.id"
        :updated-ticket="changedFields"
        :original-ticket="originalTicket">
      </update-ticket-modal>

      <add-company-modal v-model="addingCompany"/>

      <add-contact-modal 
        v-if="ticket && addingContact"
        v-model="addingContact"
        :company-id="ticket.company_id"/>

      <add-rating-modal 
        v-if="ticket && ticket.company"
        v-model="addingRating"
        :rating.sync="ticket.rating"
        :company-name="ticket.company.name"/>

      <manage-categories-modal 
        v-model="managingCategories"/>

    </div>
  <!-- </div> -->
</template>

<script>
import VSelect from '@/components/base/VSelect'
import VRichText from '@/components/base/VRichText'
import VDatepicker from '@/components/base/VDatepicker'
import UpdateTicketModal from '@/components/ticketing/UpdateTicketModal'
import AddCompanyModal from '@/components/ticketing/AddCompanyModal'
import AddContactModal from '@/components/ticketing/AddContactModal'
import AddRatingModal from '@/components/ticketing/AddRatingModal'
import ManageCategoriesModal from '@/components/ticketing/ManageCategoriesModal'

import { mapState, mapActions } from 'vuex'
import { parseISO, format } from 'date-fns'

export default {
  components: {
    VSelect,
    VRichText,
    VDatepicker,
    UpdateTicketModal,
    AddCompanyModal,
    AddContactModal,
    AddRatingModal,
    ManageCategoriesModal
  },
  data() {
    return {
      priorities: ['Low', 'Medium', 'High'],
      statuses: ['Open', 'Pending', 'On Hold', 'Resolved', 'Closed'],
      ticket: null,
      updatedTicket: {},
      originalTicket: {},
      parse: (d) => {
        return d ? parseISO(d) : null
      },
      format: (d) => {
        return d ? format(d, 'yyyy-MM-dd H:mm:ss') : null
      },
      saving: false,
      addingCompany: false,
      addingContact: false,
      addingRating: false,
      managingCategories: false
    }
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("users", ["users"]),
    ...mapState("tickets", ["companies", "contacts", "categories"]),
    changes() {
      return Object.keys(this.changedFields).length;
    },
    originalKeys() {
      return Object.keys(this.originalTicket);
    },
    changedFields({ updatedTicket, originalTicket }) {
      let res = {};
      Object.keys(updatedTicket).forEach(key => {
        if (updatedTicket[key] != originalTicket[key]) {
          res[key] = updatedTicket[key];
        }
      });

      return res;
    },
    editable({ user }) {
      return user.role == 'office-manager' || user.permission == 'admin';
    },
    companyName({ ticket }) {
      if (ticket.company_id) {
        return this.companies.filter(d => d.id == ticket.company_id)[0].name;
      } else {
        return null
      }
    }
  },
  watch: {
    'ticket.admin_notes' (newValue, oldValue) {
      if (newValue != oldValue && newValue != "") {
        this.update('admin_notes', newValue);
      }
    },
    'ticket.status' (newValue, oldValue) {
      if (
        oldValue != null &&
        ['resolved', 'closed'].indexOf(newValue.toLowerCase()) != -1 && 
        this.ticket.company_id != 0
      ) {
        this.addingRating = true;
      }
    },
    'ticket.rating' (newValue, oldValue) {
      if (newValue != oldValue) {
        this.update('rating', newValue);
      }
    },
    'ticket.company_id' (newValue) {
      this.getContacts({ company_id: newValue });
    },
    'ticket.category_id' (newValue) {
      this.fetchCompanies();
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("users", ["getUsers"]),
    ...mapActions("tickets", ["updateTicket", "getCompanies", "getContacts"]),
    initialize() {
      this.getUsers({ role: 'office-manager' });

      if (this.$route.params.ticket) {
        let ticket = Object.assign({}, this.$route.params.ticket);
        ticket.exp_solution_date = this.parse(ticket.exp_solution_date);
        this.ticket = ticket;
        this.setOriginal(this.ticket);
        this.fetchCompanies();
      } else {
        this.$http.ticketingTicket.get(
          this.$route.params.ticketId
        ).then(resp => {
          resp.data.exp_solution_date = this.parse(
            resp.data.exp_solution_date
          );
          this.ticket = resp.data;
          this.setOriginal(this.ticket);
          this.fetchCompanies();
        })
      }
    },
    fetchCompanies() {
      this.getCompanies(
        { category_id: this.ticket.category_id }
      ).then(resp => {
        if (resp.data.results.length > 0) {
          this.getContacts({ company_id: resp.data.results[0].id });
        }
      })
    },
    setOriginal(ticket) {
      const { originalTicket } = this;

      this.$set(originalTicket, 'category_id', ticket.ticket_category.id);
      this.$set(originalTicket, 'priority', ticket.priority);
      this.$set(originalTicket, 'status', ticket.status);
      this.$set(originalTicket, 'admin_assigned', ticket.admin_user.id);
      this.$set(originalTicket, 'exp_solution_date', ticket.exp_solution_date);
      this.$set(originalTicket, 'company_id', ticket.company_id);
      this.$set(originalTicket, 'contact_id', ticket.contact_id);
      this.$set(originalTicket, 'admin_notes', ticket.admin_notes);
      this.$set(originalTicket, 'rating', ticket.rating);
    },
    update(field, v) {
      this.$set(this.updatedTicket, field, v);
    }
  }
}
</script>

<style lang="scss" scoped>
.ticket-updater {
  &__container {
    padding: 1.5em;
  }
  // &__navigator {
  //   width: 20%;
  //   padding: 1.5em;
  // }
  // &__ticket {
  //   width: 80%;
  //   padding: 1.5em;
  // }
}

.label-and-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .tag {
    cursor: pointer;
    &:hover {
      background: gainsboro;
    }
  }
}
</style>